import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ClearFixIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2.92676 4C2.92676 3.44772 3.37447 3 3.92676 3H19.9268C20.479 3 20.9268 3.44772 20.9268 4C20.9268 4.55228 20.479 5 19.9268 5H3.92676C3.37447 5 2.92676 4.55228 2.92676 4ZM2.92676 9C2.92676 8.44772 3.37447 8 3.92676 8H19.9268C20.479 8 20.9268 8.44772 20.9268 9C20.9268 9.55228 20.479 10 19.9268 10H3.92676C3.37447 10 2.92676 9.55228 2.92676 9ZM2.92676 14C2.92676 13.4477 3.37447 13 3.92676 13H8.92676C9.47904 13 9.92676 13.4477 9.92676 14C9.92676 14.5523 9.47904 15 8.92676 15H3.92676C3.37447 15 2.92676 14.5523 2.92676 14ZM14.2903 14.3052C14.6808 13.9147 15.314 13.9147 15.7045 14.3052L17.4723 16.073L19.2401 14.3052C19.6306 13.9147 20.2637 13.9147 20.6543 14.3052C21.0448 14.6958 21.0448 15.3289 20.6543 15.7195L18.8865 17.4872L20.6543 19.255C21.0448 19.6455 21.0448 20.2787 20.6543 20.6692C20.2637 21.0597 19.6306 21.0597 19.2401 20.6692L17.4723 18.9014L15.7045 20.6692C15.314 21.0597 14.6808 21.0597 14.2903 20.6692C13.8998 20.2787 13.8998 19.6455 14.2903 19.255L16.0581 17.4872L14.2903 15.7195C13.8998 15.3289 13.8998 14.6958 14.2903 14.3052ZM2.92676 20C2.92676 19.4477 3.37447 19 3.92676 19H8.92676C9.47904 19 9.92676 19.4477 9.92676 20C9.92676 20.5523 9.47904 21 8.92676 21H3.92676C3.37447 21 2.92676 20.5523 2.92676 20Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ClearFixIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ClearFixIcon);
